const e = {
  base: "adyen-pe-capital-offer",
  errorContainer: "adyen-pe-capital-offer__error-container"
};
export {
  e as CAPITAL_OFFER_CLASS_NAMES
};
